var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27011 0C3.27616 0 0.0268555 3.2493 0.0268555 7.24321C0.0268555 12.1998 6.50885 19.4763 6.78483 19.7837C7.04405 20.0724 7.49663 20.0719 7.75538 19.7837C8.03136 19.4763 14.5134 12.1998 14.5134 7.24321C14.5133 3.2493 11.264 0 7.27011 0Z",
    fill: "#3A9BD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransit);
export default __webpack_public_path__ + "static/media/inTransit.da94f4a8af219e36a0d02be39e13e344.svg";
export { ForwardRef as ReactComponent };